import { useLingui } from "@lingui/react/macro";
import { Button, Input } from "@orbin/ui-web";
import { useState } from "react";
import { rpc } from "../lib/rpc";
import { errorText } from "../lib/user-error";

/** Asks for the payer's CPF or CNPJ. It is saved sealed and never shown again. */
export function TaxIdField({ onSaved }: { onSaved: () => void }) {
  const { t } = useLingui();
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function save() {
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await rpc.payments.setIdentification({ taxId: value });
      onSaved();
    } catch (cause) {
      setError(errorText(cause, t`Could not save`));
    } finally {
      setBusy(false);
    }
  }

  return (
    <form
      data-testid="tax-id-field"
      className="flex flex-col gap-2"
      onSubmit={(event) => {
        event.preventDefault();
        void save();
      }}
    >
      <Input
        aria-label={t`CPF or CNPJ`}
        inputMode="numeric"
        autoComplete="off"
        placeholder={t`CPF or CNPJ`}
        value={value}
        onChange={(event) => setValue(event.target.value)}
      />
      <Button type="submit" disabled={busy || value.replace(/\D/g, "").length < 11}>
        {t`Continue`}
      </Button>
      {error ? (
        <p role="alert" className="text-sm text-destructive">
          {error}
        </p>
      ) : null}
    </form>
  );
}

